module.exports = __webpack_public_path__ + "10_hair_gold.ff62823d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/10_hair_gold.png
// module id = pzg/
// module chunks = 0